import { ReactElement } from 'react';

import { ReactComponent as AdligoStarLogo } from 'assets/icons/logos/starLogo63.svg';
import { LanguageSelector } from 'features/languageSelector';
import { useWindowSize } from 'hooks';

import { HeaderW, LogoRow, TopRow } from './styled';

export function PageHeader(): ReactElement {
  const { isMobile } = useWindowSize();
  const logoStyles = {
    marginRight: isMobile ? '12px' : '16px',
    width: '164px',
    height: '164px',
  };

  return (
    <HeaderW>
      <TopRow>
        <LanguageSelector isAuth />
      </TopRow>
      <LogoRow>
        <AdligoStarLogo style={logoStyles} />
      </LogoRow>
    </HeaderW>
  );
}
